import LoginProvider from '@/application/providers/LoginProvider'
import Util from "@/application/libs/util"

function LoginService(){

    /**
     * Log user and catch errors
     */
    this.doLogin = (username, password)=>{
        let loginData = {
            username, 
            password
        };

        return LoginProvider.login(loginData).then(userData=>{
            if(userData && userData.loginData.length){
                Util.setLocalVar('userData', userData.loginData[0]);
                
                if(userData.paramGeralData && userData.paramGeralData.length){
                    Util.setLocalVar('backOfficeData', userData.paramGeralData[0]);
                    sessionStorage.setItem('filterData', JSON.stringify(userData.paramGeralData[0]));
                }

                if(userData.token && userData.token.length){
                    Util.setLocalVar('backoffice_token', userData.token[0]);
                }
                
                if(userData.permissions){
                    userData.permissions.scopes = userData.permissions.scopes.map(e => parseInt(e));
                    Util.setLocalVar('permissions', userData.permissions);
                }
                
                if(userData.canAccessPermissionManagement){
                    Util.setLocalVar('canAccessPermissionManagement', userData.canAccessPermissionManagement[0]);
                }

                return Promise.resolve();
            } else {
                return Promise.reject();
            }
        });
    };

    /**
     * Log out user. Exclude user data from local
     * storage and remove token from localStorage.
     */
    this.doLogout = (vueContext)=>{
        localStorage.removeItem('backoffice_token');
		localStorage.removeItem('userData');
        localStorage.removeItem('backOfficeData');
        localStorage.removeItem('permissions');
        localStorage.removeItem('canAccessPermissionManagement');
        vueContext.$router.push('/');
        vueContext.$emit('close');
    };

    this.isLogged = function(){
        return LoginProvider.testRequest();
    };
}

export default new LoginService();